<template>
    <div>
        <dropdown-popover v-show="accessToken" shadow border-thick>
            <user-avatar
                pointer
                size="large"
                :picture-url="user.picture"
                :name="user.name"
            />

            <template #tooltip>
                <div class="flex flex-col items-start py-2 w-40 md:w-auto">
                    <router-link
                        to="/app/profile"
                        class="w-full text-left md:mx-1 mx-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover p-3 rounded-lg flex items-center"
                    >
                        <span class="mr-2">🙍</span>
                        <span class="font-bold">Perfil</span>
                    </router-link>

                    <router-link
                        to="/app/configurations"
                        class="w-full text-left md:mx-1 mx-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover p-3 rounded-lg flex items-center"
                    >
                        <span class="mr-2">⚙️</span>
                        <span class="font-bold">Ajustes</span>
                    </router-link>

                    <router-link
                        to="/wiki"
                        class="w-full text-left md:mx-1 mx-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover p-3 rounded-lg flex items-center"
                    >
                        <span class="mr-2">❓</span>
                        <span class="font-bold">Ayuda</span>
                    </router-link>

                    <a
                        v-if="$isMultitenant"
                        :href="supportWhatsappLink"
                        target="_blank"
                        rel="noopener"
                        class="w-full text-left mx-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover p-3 rounded-lg flex items-center md:hidden"
                    >
                        <social-icon
                            network="whatsapp"
                            :height="5"
                            :width="5"
                            class="mr-2 text-theme-success"
                        />
                        <span class="font-bold">Soporte</span>
                    </a>

                    <button
                        v-if="canDeselect"
                        class="w-full text-left md:mx-1 mx-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover p-3 rounded-lg flex items-center"
                        @click="onClearTenant"
                    >
                        <span class="mr-2">🤖</span>
                        <span class="font-bold">Modo Admin</span>
                    </button>

                    <div class="w-full h-px bg-theme-border my-1"></div>

                    <button
                        class="w-full text-left md:mx-1 mx-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover active:bg-theme-hover p-3 rounded-lg flex items-center text-theme-danger"
                        @click="handleLogout"
                    >
                        <span class="mr-2">❌</span>
                        <span class="font-bold">Salir</span>
                    </button>
                </div>
            </template>
        </dropdown-popover>

        <div v-show="!accessToken" class="flex">
            <app-button border to="/login">
                <span class="font-bold">Inicia Sesión</span>
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { SUPPORT_WHATSAPP_LINK } from "@/common/constants";

import SocialIcon from "@/components/icons/SocialIcon.vue";
import UserAvatar from "@/components/utils/UserAvatar.vue";

export default {
    name: "OptionsUser",
    components: { UserAvatar, SocialIcon },
    data: () => ({}),
    computed: {
        ...mapState("auth", ["accessToken", "user"]),
        ...mapGetters("control", ["backgroundColor"]),
        ...mapState("auth", ["tenantId"]),
        supportWhatsappLink() {
            return SUPPORT_WHATSAPP_LINK;
        },
        canDeselect() {
            return (
                !!this.tenantId &&
                this.$ability.hasGlobalPermission("tenant:Select")
            );
        }
    },
    mounted() {},
    methods: {
        ...mapActions("auth", ["signOut", "removeTenantContext"]),

        async handleLogout() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: "¿ Deseas cerrar tu sesión ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ee3f59",
                cancelButtonColor: "#02913f",
                confirmButtonText: "Si",
                cancelButtonText: "No"
            });

            if (dialogResult.isConfirmed) {
                await this.signOut();
            }
        },
        async onClearTenant() {
            const result = await this.$swal.fire({
                background: this.backgroundColor,
                title: "¿Deseleccionar tenant?",
                text: "Volverás al contexto global. El merchant activo también se limpiará.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar"
            });
            if (!result.isConfirmed) return;
            this.$loading.show();
            try {
                await this.removeTenantContext();
                this.$sound.play();
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
